import { Injectable, Injector } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { EMPTY, Observable, throwError } from "rxjs";
import { tap, catchError, switchMap } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { AuthenticationService } from "../services/authentication.service";
import { ToasterService } from "../services/toaster/toaster.service";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";

const REDIRECT_AFTER = 2000;

@Injectable()
export class MetadataInterceptor implements HttpInterceptor {
  constructor(
    public dialogBox: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router,
    private toasterService: ToasterService,
    private route: ActivatedRoute
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.error === "PASSWORD_FAILED" ||
          error.error === "USER_FAILED" ||
          error.error === "SITE_FAILED"
        ) {
          return throwError(error);
        }
        if (error.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
          return;
        }
        if (error.error && error.error.metadata) {
          return this.parseActions(error.error.metadata, error);
        } else {
          this.popupError(error);
          return throwError(error);
        }
        //
      }),
      tap((event: HttpEvent<any>) => {
        // console.log(event);
        if (event instanceof HttpResponse) {
          // Redirect
          if (event.body && event.body.metadata) {
            this.parseActions(event.body.metadata);
          }
        }
      })
    );
  }
  popupError(error) {
    const metadata = {
      dialog: {
        error: error?.error,
        errors: error?.errors,
        message: error?.message,
        statusText: error?.statusText,
      },
    };
    this.parseActions(metadata);
  }
  parseActions(metadata, error?): Observable<any> {
    const { redirect, toast, dialog } = metadata;

    if (redirect) {
      this.redirect(redirect);
    }
    if (toast) {
      this.toasterService.toast(
        toast.level || "success",
        toast.key,
        {},
        toast.data
      );
    }
    if (dialog) {
      return this.openDialog(dialog, error);
    }
  }

  redirect(routerLink) {
    this.toasterService.toast("success", "REDIRECT", {}, {});
  }
  openDialog(dialog, error?): Observable<any> {
    const { $type, ...datas } = dialog;
    datas.title = $localize`ERROR`;
    const dialogRef = this.dialogBox.open(ErrorDialogComponent, {
      width: "99%",
      data: datas,
    });
    return dialogRef.afterClosed().pipe(
      switchMap((_) => {
        return throwError(error);
      })
    );
  }
}
